import React, { Component } from "react"

/* Icons */
import { CaretDownOutlined } from '@ant-design/icons'

/* Constants */
import { env, utils } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"

/* Moment */
import moment from "moment"
import 'moment/locale/ru'
moment.locale('ru')


/* Component History */
class History extends Component {

    constructor() {
        super()

        this.state = {
            active: -1
        }
    }


    /* Determine and draw total */
    _total = data => {

        let total = 0
        let currency = "USD"

        if (data.transactions && Array.isArray(data.transactions) && data.transactions.length > 0) {

            data.transactions.forEach(transaction => {

                if (transaction.type === 'credit') {
                    total = total + parseFloat(transaction.total)
                }

                if (transaction.type === 'debit') {
                    total = total - parseFloat(transaction.total)
                }

                currency = transaction.currency

            })

        }

        if (total > 0) {
            return <div className="history-head-total">&nbsp;+{utils.convertor(Math.abs(total), currency)}</div>
        }

        if (total < 0) {
            return <div className="history-head-total">&nbsp;-{utils.convertor(Math.abs(total), currency)}</div>
        }

        return <div className="history-head-total">&nbsp;{utils.convertor(total, currency)}</div>
    }


    /* Draw time */
    _time = data => {

        if (data.createdAt) {

            const date = moment(data.createdAt).format("YYYY-MM-DD")
            const today = moment(new Date()).format("YYYY-MM-DD")

            const yesterdayD = new Date()
            yesterdayD.setDate(yesterdayD.getDate() - 1)
            const yesterday = moment(yesterdayD).format("YYYY-MM-DD")

            let text = date

            if (moment(date).isSame(today, 'day')) {
                text = 'Сегодня'
            }
            else if (moment(date).isSame(yesterday, 'day')) {
                text = 'Вчера'
            }

            return (
                <div className="history-head-datetime">
                    <div className="history-head-time">{moment(data.createdAt).format("HH:mm")}</div>
                    <div className="history-head-date">{text}</div>
                </div>
            )
        }
    }


    /* Draw cards */
    _cards = data => {

        let dealer = []
        let player = []
        let playerGame = null

        /* PLAYER GAME */
        if (data.results && Array.isArray(data.results) && data.results.length > 0) {
            playerGame = data.results[0]
        }

        /* Cards */
        if (Array.isArray(data.cards) && data.cards.length > 0) {
            data.cards.forEach(card => {
                if (card.type === "dealer") {
                    dealer.push(card)
                }
                if (card.type === "player") {
                    player.push(card)
                }
            })
        }

        return (
            <div className="modal-boxes">

                <div className="rmp--modal-box-item">
                    {dealer.length > 0 ? <div className="modal-box-text">Дилер</div> : null}
                    {(data.dealerResult && data.dealerMultiplier) ? <p>{data.dealerResult}{parseInt(data.dealerMultiplier) > 0 ? ` : (${data.dealerMultiplier} : 1)` : ''}</p> : null}
                    <div className="modal-cards">
                        {dealer.map((card, index) =>
                            <div key={`${index}`} className="modal-card-item">
                                <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                <span>{card.status === "buy" ? "BUY" : ""} </span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="rmp--modal-box-item">
                    {player.length > 0 ? <div className="modal-box-text">Игрок</div> : null}
                    {playerGame !== null ? <p>{playerGame.result}{playerGame.multiplier && parseInt(playerGame.multiplier) > 0 ? ` : (${playerGame.multiplier} : 1)` : ''}</p> : null}
                    <div className="modal-cards">
                        {player.map((card, index) =>
                            <div key={`${index}`} className="modal-card-item" style={{ opacity: card.status === "hidden" ? 0.5 : 1 }}>
                                <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                <span>{card.status === "exchange" ? "EXC" : card.status === "sixth" ? "6-TH" : card.status === "fifth" ? "5-TH" : ""}</span>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        )

    }


    /* Draw current game */
    _currentGame = () => {

        /* Props and state */
        const { info, transactions } = this.props
        const { active } = this.state

        if (info && (transactions && Array.isArray(transactions) && transactions.length > 0)) {
            return (
                <div className="history-item">

                    <div onClick={() => this.setState({ active: active === 'current' ? -1 : 'current' })} className={`history-head ${'current' === active ? 'history-active-head' : ''}`}>
                        <div className="history-number">Игра #{info.number} <div> (ТЕКУЩАЯ ИГРА)</div></div>
                        <CaretDownOutlined />
                    </div>

                    <div className={`history-hidden-box ${'current' === active ? 'history-hidden-box-active' : ''}`}>

                        <div className="history-transactions">
                            <div className="history-transaction-text">Транзакции</div>
                            {transactions.map((transaction, tk) =>
                                <div className="history-transaction-item" key={`${tk}`}>
                                    <div className="history-transaction-reason">{transaction.reason} {(transaction.box && parseInt(transaction.box) > 0) ? `(BOX ${transaction.box})` : ''}</div>
                                    <div className={`history-transaction-price ${transaction.type === 'credit' ? 'history-transaction-green-price' : ''}`}> {transaction.type === 'credit' ? "+" : "-"} {utils.convertor(transaction.total, transaction.currency)}</div>
                                    <div className="history-transaction-time">{moment(transaction.createdAt).format("Do MMM YYYY, hh:mm")}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        }

        return null
    }

    /* Operations list */
    operationsList = (item, index) => {

        const { currency } = this.props

        if (item.processes && Array.isArray(item.processes) && item.processes.length > 0) {

            let total = 0
            let totalWin = 0

            item.processes.forEach(item => {
                if (item.total && item.type !== 'maxpay') {
                    total += parseFloat(item.total)
                }
                if (item.win) {
                    totalWin += parseFloat(item.win)
                }
            })

            return (
                <div className="history-transactions" key={`o-t-${index}`}>
                    <table className="operations-table">
                        <thead>
                            <tr>
                                <th>Вид ставки</th>
                                <th>Cтавка</th>
                                <th>Выигрыш</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                item.processes.map((item, index) => {
                                    const processStyle = item.type === 'pass' ? 'pass' : item.type === 'maxpay' ? 'gold' : ''

                                    if (item.type === 'maxpay') {
                                        return (
                                            <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                                <td colSpan={3}>Вам выплатили максимальную сумму - {utils.convertor(item.total, currency)}</td>
                                            </tr>
                                        )
                                    }

                                    return (
                                        <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                            <td>{item.reason}</td>
                                            <td>{utils.convertor(item.total, currency)}</td>
                                            <td>{utils.convertor(item.win ? item.win : 0, currency)}</td>
                                        </tr>
                                    )
                                })
                            }

                            <tr key={`h-o-total`}>
                                <td>Итого</td>
                                <td>{utils.convertor(total, currency)}</td>
                                <td>{utils.convertor(totalWin, currency)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            )
        }

        return null
    }

    render = () => {

        /* Props and state */
        const { visible, close, histories, loadMore, historyHasMore, always } = this.props
        const { active } = this.state

        /* Fields */
        const animated = visible ? 'animated' : ''
        const bottomStyle = histories.length > 10 ? 'initial' : ''


        return (
            <div className={`modal history ${always} ${animated}`}>
                <div className='modal-content'>

                    {/* Modal Header */}
                    <div className='modal-header'>
                        История игры
                        <div onClick={() => close()} className="modal-close">
                            <Picture src={`${env.mediapoint}/images/x.png`} alt="CLOSE" />
                        </div>
                    </div>

                    {/* Modal Body */}
                    <div className='modal-body'>

                        {/* The current game */}
                        {this._currentGame()}

                        {/* Old games */}
                        {histories.map((item, index) => {

                            let endBalance = parseFloat(item.startBalance)

                            const transactions = item.transactions


                            if (transactions && Array.isArray(transactions) && transactions.length > 0) {
                                transactions.forEach(transaction => {
                                    if (transaction.type === 'credit') {
                                        endBalance = endBalance + parseFloat(transaction.total)
                                    }
                                    if (transaction.type === 'debit') {
                                        endBalance = endBalance - parseFloat(transaction.total)
                                    }
                                })
                            }

                            return (
                                <div className="history-item" key={`${index}`}>

                                    {/* Draw history head */}
                                    <div onClick={() => this.setState({ active: active === index ? -1 : index })} className={`history-head ${index === active ? 'history-active-head' : ''}`}>

                                        <div className="history-number">
                                            Игра #{item.number}
                                            {/* {index === 0 && <div className="history-number-text"> (LAST GAME)</div>} */}
                                        </div>

                                        <div className="history-head-right">
                                            {this._total(item)}
                                            {this._time(item)}
                                            <CaretDownOutlined />
                                        </div>

                                    </div>

                                    <div className={`history-hidden-box ${index === active ? 'history-hidden-box-active' : ''}`}>

                                        {item.dealer ? <div className="history-dealer">Дилер: {item.dealer}</div> : null}

                                        {item.endReason ? <div className="history-reason-error">{item.endReason}</div> : null}

                                        {(transactions && Array.isArray(transactions) && transactions.length > 0) &&
                                            <div className="history-transactions">

                                                {(item.startBalance !== null || item.startBalance !== undefined) && <div className="history-transaction-balance">Баланс до игры: {utils.convertor(item.startBalance, transactions[0].currency)}</div>}
                                                {endBalance > 0 && <div className="history-transaction-balance">Баланс после игры: {utils.convertor(endBalance, transactions[0].currency)}</div>}

                                                {this.operationsList(item, index)}

                                            </div>
                                        }

                                        {this._cards(item)}

                                    </div>
                                </div>
                            )
                        })}

                        {historyHasMore &&
                            <div className={`modal-bottom ${bottomStyle}`}>
                                <div className="modal-load-more" onClick={() => loadMore()}>Загрузить еще</div>
                            </div>
                        }

                        <div className="modal-bottom-space" />

                    </div>
                </div>
            </div>

        )

    }

}

export default History